<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Quality Management
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Quality Management"
      text="Create Quality Management"
      class="mb-0"
    > 
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="name"
              v-validate="'required'"
              :error-messages="errors.collect('name')"
              data-vv-name="name"                
              label="Name"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="employeeSearchInput"
              placeholder="Filter employee by name"
              append-icon="search"
              label="Search Employee By Name"
              hide-no-data
              hide-selected
            />

            <v-autocomplete
              v-model="filters.departments"
              :items="departments"
              item-text="name"
              item-value="id"
              value="id"
              label="Search Employee By Department"
              placeholder="Filter employee by department"
              clearable
              hide-selected
              multiple
              deletable-chips
              small-chips
              chips
            />

            <v-data-table
              v-model="selectedEmployees"
              :items="filteredEmployees"
              :headers="employeeHeaders"
              hide-default-footer
              fixed-header
              disable-pagination
              show-select 
              dense
              item-key="employee_uid"
              item-value="employee_uid"
              :loading="loading"
              height="330px"
              class="elevation-2 mb-3"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Employee Selection:</v-toolbar-title>
                </v-toolbar>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="departmentSearchInput"
              placeholder="Filter department by name"
              append-icon="search"
              label="Search Department"
              hide-no-data
              hide-selected
            />

            <v-autocomplete
              disabled
              style="opacity:0"
            />
              
            <v-data-table
              v-model="selectedDepartments"
              :items="filteredDepartments"
              :headers="departmentHeaders"
              hide-default-footer
              fixed-header
              disable-pagination
              show-select 
              dense
              :loading="loading"
              height="330px"
              class="elevation-2 mb-3"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Department Selection:</v-toolbar-title>
                </v-toolbar>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        name: null,
        departments: [],
        employees: [],
        progressing: false,
        loading: false,
        dialog: null,
        employeeSearchInput: '',
        departmentSearchInput: '',
        filters: {
          departments: '',
        },
        selectedEmployees: [],
        selectedDepartments: [],
        departmentHeaders: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
        ],
        employeeHeaders: [
          {
            text: 'Name',
            align: 'left',
            value: 'person.name',
          },
        ],
      }
    },
    computed: {
      filteredEmployees () {
        let _this = this
        _this.employeeSearchInput = _this.employeeSearchInput.trim()
        let primaryFilterEmployees = this.employees.filter(function (employee) {
          return ((employee.person || {}).name || '').toLowerCase().indexOf(_this.employeeSearchInput.toLowerCase()) !== -1 ||
            ((employee.person || {}).username || '').toLowerCase().indexOf(_this.employeeSearchInput.toLowerCase()) !== -1
        })

        let filteredDepartments = this.customFilterDepartments(primaryFilterEmployees)
        return filteredDepartments
      },

      filteredDepartments () {
        let _this = this
        _this.departmentSearchInput = _this.departmentSearchInput.trim()
        let primaryFilterDepartments = this.departments.filter(function (department) {
          return ((department || {}).name || '').toLowerCase().indexOf(_this.departmentSearchInput.toLowerCase()) !== -1 
        })

        return primaryFilterDepartments
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
        this.loadData()
      },
    },
    methods: { 
      loadData () {
        this.loading = true

        Promise.all([
          this.$api.employees().list('?with=active'),
          this.$api.departments().list(),
        ])
          .then(([employees, departments]) => {
            let temp = employees.data.filter(employee => {
              return employee.department_id !== null
            })

            this.employees = _.orderBy(temp, ['person.name', 'department.name'], ['asc', 'asc'])       
            this.departments = departments.data

            this.loading = false
          })
      },
      prepareFormData () {
        return {
          name: this.name,
          employeeUids: this.getEmployeeUids(),
          departmentIds: this.getDepartmentIds(),
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
        
            this.$api.qualityManagement().create(this.prepareFormData())
              .then((res) => {
                this.$emit('created')                
                this.$snack({ message: 'Quality management created' })
                
                this.progressing = false
                this.dialog = false                
              })
              .catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Failed to create quality management', 
                })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },

      getEmployeeUids () {
        let employeeUids = []

        this.selectedEmployees.map(item => {
          employeeUids.push(item.employee_uid)
        })

        return employeeUids
      },

      getDepartmentIds () {
        let departmentIds = []

        this.selectedDepartments.map(item => {
          departmentIds.push(item.id)
        })

        return departmentIds
      },
      resetForm () {
        this.$validator.reset()
        this.name = null
        this.selectedEmployees = []
        this.selectedDepartments = []
      },

      customFilterDepartments (employeesList) {
        if (this.filters.departments.length === 0) return employeesList

        return employeesList.filter(employee => {
          return _.intersection([employee.department_id], this.filters.departments).length > 0
        })
      },
    },
  }
</script>
